





































import { Component, Prop, Vue } from "vue-property-decorator";
import { ViewType } from "@/App.vue";

@Component
export default class BtnChangeView extends Vue {
  @Prop() readonly type!: string;
  @Prop() readonly changeType!: Function;

  get label() {
    let text;

    if (this.type === "LIST") {
      text = "таблицу";
    } else {
      text = "список";
    }

    return text;
  }

  handleClick() {
    if (this.type === ViewType.List) {
      this.changeType(ViewType.Table);
    } else {
      this.changeType(ViewType.List);
    }
  }
}
